function Registration() {
    return (
        <div>
            <p>All persons attending the Conference must complete an online registration form. Please read the below information before you complete the online registration form.</p>
            <p>Should you require further assistance, contact <a href="mailto:contact@ietbhec.com">contact@ietbhec.com</a></p>
            <h2>Registration</h2>
            <p className="font-italic">Note: The registration fees are set to SGD (Singapore Dollars) (as a base currency) for all participants.</p>
            <table className="table table-bordered">
                <tbody>
                    <tr>
                        <td>Type of registration</td>
                        <td>Fee (SGD)</td>
                        <td>Payment Link</td>
                        <td>Promotion Code for Early Bird</td>
                    </tr>
                    <tr>
                        <td>Full Registration- Early Bird</td>
                        <td>400.00</td>
                        <td> <a href="https://buy.stripe.com/aFaaEWcE98a8e843Z77wA0C">IETBHEC’26 - Full Registration - Standard</a> </td>
                        <td><font color="red">EARLYBIRDSTANDARD</font></td>
                    </tr>
                    <tr>
                        <td>Full Registration- Student (Early Bird)</td>
                        <td>275.00</td>
                        <td> <a href="https://buy.stripe.com/7sY00i5bH3TS9RObrz7wA0D">IETBHEC’26 - Full Registration - Standard (Student)</a> </td>
                        <td><font color="red">EARLYBIRDSTUDENT</font></td>
                    </tr>
                    <tr>
                        <td>Full Registration- Standard</td>
                        <td>500.00</td>
                        <td> <a href="https://buy.stripe.com/aFaaEWcE98a8e843Z77wA0C">IETBHEC’26 - Full Registration - Standard</a> </td>
                        <td><font color="red">EARLYBIRDSTANDARD</font></td>
                    </tr>
                    <tr>
                        <td>Full Registration- Standard (Student)</td>
                        <td>300.00</td>
                        <td> <a href="https://buy.stripe.com/7sY00i5bH3TS9RObrz7wA0D">IETBHEC’26 - Full Registration - Standard (Student)</a> </td>
                        <td><font color="red">EARLYBIRDSTUDENT</font></td>
                    </tr>
                    <tr>
                        <td>Single Day / Accompanying Person Registration</td>
                        <td>250.00</td>
                        <td> <a href="https://buy.stripe.com/4gMcN4gUp3TSfc88fn7wA0G">IETBHEC’26 - Single Day / Accompanying Person Registration</a> </td>
                        <td>-</td>
                    </tr>
                    <tr>
                        <td>Extra Conference Gala Banquet Ticket</td>
                        <td>220.00</td>
                        <td> <a href="https://buy.stripe.com/8x2dR85bHgGE0he67f7wA0E">IETBHEC’26 - Extra Conference Gala Banquet Ticket</a> </td>
                        <td>-</td>
                    </tr>
                </tbody>
            </table>
            {/* <p>*Early bird registration closes on Friday, 10 October 2025.</p> */}
            <p>For student registration valid proof is required as a full-time student for the attendance.</p>
            <p className="font-weight-bold" class="no-newline-after-p">Accompanying spouse/partner registration fee includes:</p>
            <ul className="ml-5">
                <li>Morning and afternoon teas and lunches (at the conference venue)</li>
                <li>One ticket to attend the Conference Gala Banquet</li>
            </ul>
            <br></br>
            <p>
                It is the requirement of IETBHEC’26 to register all accompanying persons attending the conference.
            </p>
            <p className="font-weight-bold">Entitlements</p>
            <p class="no-newline-after-p">All Full and student registration fees include:</p>
            <ul className="ml-5">
                <li>Admission to all conference sessions (excluding Master class/workshops)</li>
                <li>Conference proceedings</li>
                <li>Conference program</li>
                <li>Conference kit including satchel/bag</li>
                <li>Morning and afternoon teas and lunches</li>
                <li>One ticket to attend the Conference Gala Banquet (Dinner). </li>
            </ul>
            <br></br>
            <p>
                In case that two papers are authored and presented by the same participant, the registration fee for second paper is SGD250 (equivalent to single day registration fee). Full fees must be paid for the third and subsequent papers.
            </p>
            <p className="font-weight-bold">Cancellations</p>
            <p>All requests for cancellations must be in writing. Cancellations on or before 05 - 07 July 2026, will incur a fee of SGD100. No refunds will be made for cancellations after this date.</p>
        </div>
    )
}

export default Registration